import { useState } from "react";

export default function CtfIntro() {
  const [comingSoon, setComingSoon] = useState(false);

  const handleClick = () => {
    setComingSoon(true);
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">🚩 CTF Lab</h1>

      {/* CTF ITEM */}
      <div
        onClick={handleClick}
        className="bg-red-500/10 border border-red-500/30 rounded-xl p-6 cursor-pointer hover:bg-red-500/20 transition"
      >
        <h3 className="font-semibold">Hidden Flag</h3>
        <p className="text-gray-400 text-sm mt-1">
          Static analysis based challenge
        </p>
        <span className="text-xs text-red-400 mt-3 inline-block">
          Open →
        </span>
      </div>

      {/* COMING SOON */}
      {comingSoon && (
        <div className="mt-6 bg-white/5 border border-dashed border-gray-600 rounded-xl p-6 text-center">
          🚧 <span className="font-semibold text-yellow-400">CTF Engine</span>
          <br />
          <span className="text-gray-400 text-sm">
            Coming Soon
          </span>
        </div>
      )}
    </div>
  );
}
